import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { TIMELINE_OPTIONS, type LeadFormData } from "../types";

interface Props {
  data: LeadFormData;
  onChange: (patch: Partial<LeadFormData>) => void;
  onAdvance?: () => void;
}

export function StepTimeline({ data, onChange, onAdvance }: Props) {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue">
          <Clock className="h-4 w-4" />
          Timeline
        </div>
        <h2 className="text-balance text-3xl font-bold tracking-tighter text-foreground sm:text-4xl">
          When are you looking to launch?
        </h2>
        <p className="text-base text-muted-foreground">
          We'll match the right plan to your timeline.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {TIMELINE_OPTIONS.map((opt) => {
          const selected = data.launchTimeline === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => {
                onChange({ launchTimeline: opt.value });
                onAdvance?.();
              }}
              className={cn(
                "w-full rounded-xl border bg-background px-5 py-4 text-left text-sm font-medium text-gray-950 transition-all",
                "hover:border-brand-blue hover:shadow-sm",
                selected
                  ? "border-brand-blue bg-brand-blue/5 ring-2 ring-brand-blue/30"
                  : "border-border",
              )}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
